import { render, staticRenderFns } from "./festival.vue?vue&type=template&id=7ed047d9&scoped=true"
import script from "./festival.vue?vue&type=script&lang=js"
export * from "./festival.vue?vue&type=script&lang=js"
import style0 from "./festival.vue?vue&type=style&index=0&id=7ed047d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed047d9",
  null
  
)

export default component.exports